import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Tools } from "@app/util/tools";

@Component({
    selector: 'app-account-declined-dialog',
    template: require('./dialogAccountDeclined.html')
})
export class AccountDeclinedDialog {

    constructor(
        @Inject(Tools) public tools: any,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MatDialogRef<AccountDeclinedDialog>) public dialogRef: MatDialogRef<AccountDeclinedDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }


}
